import http from 'services/http'
import storage from 'services/storage'

const VESTBEE_AUTH_TOKEN_KEY = 'VESTBEE_AUTH_TOKEN_KEY'
const NEWSLETTER_EMAIL_KEY = 'VESTBEE_NEWSLETTER_EMAIL'

let user

export default class Auth {
  static obtainAuthToken(email, password) {
    return http
      .post(
        '/auth/obtain-auth-token',
        {
          email: email,
          password: password,
        },
        { Authorization: null },
      )
      .then((res) => {
        Auth.storeToken(res.data.token)
      })
  }

  static changePassword({ password, newPassword }) {
    return http.postAuthed('/auth/change-password', {
      password,
      new_password: newPassword,
    })
  }

  static setNewPassword({ newPassword }) {
    return http.postAuthed('/auth/set-new-password', {
      new_password: newPassword,
    })
  }

  static resetPassword({ userId, password, token }) {
    return http.postAuthed('/auth/reset-password', {
      user_id: userId,
      password,
      token,
    })
  }

  static requestPasswordReset({ email }) {
    return http.post('/auth/request-password-reset', { email })
  }

  static storeToken(token) {
    storage.set(VESTBEE_AUTH_TOKEN_KEY, token)
  }

  static obtainAuthTokenWithPasscode(eventSlug, passcode) {
    return http
      .post(
        '/auth/obtain-auth-token-with-passcode',
        {
          event_slug: eventSlug,
          passcode: passcode,
        },
        { Authorization: null },
      )
      .then((res) => {
        storage.set(VESTBEE_AUTH_TOKEN_KEY, res.data.token)
      })
  }

  static sendMagicLink(email) {
    return http.post('/auth/send-magic-link', { email: email })
  }

  static useMagicLink(userId, passcode) {
    return http
      .post('/auth/use-magic-link', { user_id: userId, passcode: passcode })
      .then((res) => {
        storage.set(VESTBEE_AUTH_TOKEN_KEY, res.data.token)
      })
  }

  static _signup(path, { email, password, name }) {
    return http.post(path, {
      email,
      password,
      name,
    })
  }

  static signup(email, password) {
    return this._signup('/auth/register', { email, password })
  }

  static signupOrganizer(email, password, name = '') {
    return this._signup('/auth/register-organizer', { email, password, name })
  }

  static async activate({ userId, activationToken }) {
    const request = http.post(`/auth/activate/${userId}`, {
      token: activationToken,
    })
    return request
  }

  static async activateForEvent({ userId, eventId, token }) {
    const request = http.post(`/auth/activate-with-event-invite`, {
      user_id: userId,
      event_id: eventId,
      token,
    })
    return request
  }

  static async activateForShowroomPrivate({
    userId,
    eventId,
    token,
    privateToken,
  }) {
    const request = http.post(`/auth/activate-with-showroom-invite`, {
      user_id: userId,
      event_id: eventId,
      token,
      private_token: privateToken,
    })
    return request
  }

  static getAuthToken() {
    return storage.get(VESTBEE_AUTH_TOKEN_KEY)
  }

  static hasAuthToken() {
    return !!storage.get(VESTBEE_AUTH_TOKEN_KEY)
  }

  static getCurrentUser() {
    if (!user) {
      user = { isAuthenticated: false }
      Auth.refetchCurrentUser()
    }
    return user
  }

  static refetchCurrentUser() {
    user = Auth.getCurrentUser()
    Auth.fetchProfile()
      .then((res) => {
        user.isAuthenticated = true
        Object.assign(user, res.data)
      })
      .catch((res) => {
        user.isAuthenticated = false
      })
    return user
  }

  static logout() {
    console.log(' => logout !')
    storage.set(VESTBEE_AUTH_TOKEN_KEY, null)
    if (user) {
      user.isAuthenticated = false
      user.email = null
    }
  }

  static fetchProfile() {
    throw new Error(
      "Do not use fetchProfile anymore - please use this.$store.dispatch('user/fetch') instead",
    )
    return http.getAuthed('/auth/me')
  }

  static subscribe(email, type) {
    return http.post('/auth/subscribe', { email, type }).then((res) => {
      storage.set(NEWSLETTER_EMAIL_KEY, email)
    })
  }

  static resendActivationLink({ email }) {
    return http.post('/auth/resend-activation-link', { email })
  }
}

export const permsMap = {
  admin: {
    ORGANIZATIONS: 'organizations',
    ORGANIZATIONS_APPROVES: 'organizations.approves',
    ORGANIZATIONS_REACTIONS: 'organizations.reactions',
    STARTUPS: 'startups',
    MAILS: 'mails',
    CHATS: 'chats',
    MARKETPLACE: 'marketplace',
    USERS: 'users',
    USERS_ACTIVITY: 'users.activity',
    USERS_MANAGE_PERMISSIONS: 'users.manage_permissions',
  },
}

export const hasPerm = (user, perm) => {
  return user.permissions.has(perm)
}

export const hasAllPerms = (user, perms) => {
  for (const perm of perms) {
    if (!user.permissions.has(perm)) {
      return false
    }
  }
  return true
}

window.Auth = Auth
